export default __webpack_public_path__ + "static/proposal-32cff0728c1f141d09a010fbf7f56bcd.png";